<template>
  <div class="main-image-wrapper">
    <div
      class="main-image"
      :style="getBackgroundImage()"
    >
      <div class="texts">
        <h3>{{ largeText }}</h3>
        <p>{{ smallText }}</p>
      </div>
    </div>
  </div>
</template>
<script>
  import ImageHelpers from 'utils/mixins/ImageHelpers'

  export default {
    mixins: [
      ImageHelpers
    ],
    props: {
      largeText: {
        type: String,
        required: false,
        default: ''
      },
      smallText: {
        type: String,
        required: false,
        default: ''
      },
      desktopImage: {
        type: String,
        required: false,
        default: ''
      },
      tabletImage: {
        type: String,
        required: false,
        default: ''
      },
      mobileImage: {
        type: String,
        required: false,
        default: ''
      }
    },
    methods: {
      getBackgroundImage () {
        const data = {
          desktop: this.desktopImage,
          tablet: this.tabletImage,
          mobile: this.mobileImage
        }

        return this.$_ImageHelpers_getBackgroundImage(
          this.$_ImageHelpers_responsiveImage(data)
        )
      }
    }
  }
</script>

<style lang="scss" scoped rel="stylesheet/scss">
  @import "~assets/styles/common.scss";

  .main-image-wrapper {

    .main-image {
      width: 100%;
      height: 200px;
      background-size: cover;
      background-color: transparent;
      background-repeat: no-repeat;
      background-position: center center;

      @include bp-mf-tablet() {
        height: 365px;
      }

      @include bp-mf-desktop() {
        height: 439px;
      }
    }

    .texts {
      display: none;
      text-align: center;

      @include bp-mf-tablet() {
        padding-top: 180px;
        display: block;
      }

      @include bp-mf-desktop() {
        padding-top: 208px;
      }

      h3 {
        max-width: 590px;
        font-size: em(20);
        font-weight: 400;
        line-height: 1.5;
        margin: 0 auto 26px auto;
        color: #ffffff;

        @include bp-mf-desktop() {
          max-width: 735px;
          font-size: em(25);
        }
      }

      p {
        color: $grey;
        font-size: em(16);
      }
    }
  }
</style>
